import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    donate: {
        id: "donateBanner.cta",
    },
    h4: {
        id: "donateBanner.h4",
    },
    p: {
        id: "donateBanner.p",
    },
});

export default messages;
